import { Grid, IconButton, Tooltip } from '@mui/material';

const SmallIcon = props => {
  return (
    <Tooltip title={props?.disabled ? '' : props?.title}>
      <Grid>
        <IconButton
          data-testid={props?.testId ? props?.testId : 'iconButton'}
          variant={props.variant ?? 'outlined'}
          {...props}
          title={undefined}
          sx={{
            width: '2.5rem',
            height: '2.5rem',
          }}>
          {props.children}
          <props.icon fontSize='small' />
        </IconButton>
      </Grid>
    </Tooltip>
  );
};

export default SmallIcon;
